import { Box, ButtonBase } from "@mui/material";
import { useHistory } from "react-router-dom";
import viewpaths from "global/constants/ViewPathConstants";
import reportsStyles from "../Reports.styles";

const styles = reportsStyles;

const VIEWS = [
  {
    key: "insights" as const,
    label: "Insights",
    path: viewpaths.insightsViewPath,
  },
  {
    key: "reports" as const,
    label: "Reports",
    path: viewpaths.reportsViewPath,
  },
];

interface AnalyticsViewToggleProps {
  /** Which of the two pages is on screen. */
  current: "insights" | "reports";
}

/**
 * Insights ▸ Reports segmented switch.
 *
 * `Reports - Mobile & Tablet.dc.html` draws the two analytics pages as one
 * screen with a switch at the top; the desktop reference has no such control
 * and reaches them through the side nav, which below `lg` is behind the
 * hamburger. The switch is therefore rendered from `md` down only (see
 * `styles.viewToggle`) and simply routes — neither page's behaviour changes.
 */
const AnalyticsViewToggle = ({ current }: AnalyticsViewToggleProps) => {
  const history = useHistory();

  return (
    <Box sx={styles.viewToggle} role="group" aria-label="Analytics view">
      {VIEWS.map((view) => {
        const active = view.key === current;
        return (
          <ButtonBase
            key={view.key}
            disableRipple
            // Not a tab: each half is a separate route, so it reads as a link
            // to a page rather than a panel switch (WCAG 4.1.2).
            aria-current={active ? "page" : undefined}
            onClick={() => {
              if (!active) history.push(view.path);
            }}
            sx={styles.viewTogglePill(active)}
          >
            {view.label}
          </ButtonBase>
        );
      })}
    </Box>
  );
};

export default AnalyticsViewToggle;
